export default __webpack_public_path__ + "static/media/team-vector2.dfb35bae.png";